import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Label,
  FormGroup,
  Form,
  Input,
  Button,
  Row,
  Col
} from 'reactstrap';
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from 'react-router-dom';
import { translate } from "react-translate";
 import { actionGetPractices } from "store/actions/practicesActions";
import { 
  actionGetKitTypes, 
  actionGetKitsCount
} from 'store/actions/kitsActions';
import { 
  actionSetEditOrder, 
  actionOrderSubmitForm, 
  actionGetReservedKits, 
  actionSetReservedKits,
  actionAutoAssignKits,
  actionOrderSubmitEdition
} from 'store/actions/practiceOrdersActions';

import { actionGetOrder } from 'store/actions/practiceOrdersActions';
import KitOverview from "./KitOverview";
//import ReservedKitList from './ReservedKitList';

const PracticeOrdersForm = (props) => {
  const dispatch = useDispatch();
  const { t } = props;
  const history = useHistory();
  const { id } = useParams();

  const { orderEdit, reservedKits, kitDeleteLoading } = useSelector(state => state.practiceOrdersReducer);
  const kitTypes = useSelector(state => state.kitsReducer.types);
  const kitsCount = useSelector(state => state.kitsReducer.kitsCount);
  const { practices } = useSelector(state => state.practicesReducer.practices);

  const [practicePick, setPracticePick] = useState("");
  const [edited, setEdited] = useState(false);
  
  const { register, handleSubmit } = useForm({
    defaultValues: {
      practice: Object.keys(orderEdit).length ? orderEdit.ordered_by.practice_id : "",
    }
  });
  
  const onSubmit = (data) => {
    if (Object.keys(orderEdit).length) {
      dispatch(actionOrderSubmitEdition({
        ...data,
        _id: orderEdit._id
      }));
      setEdited(false);
    } else {
      dispatch(actionOrderSubmitForm(data));
      setEdited(false);
    }
  };

  useEffect(() => {

    if (!Object.keys(orderEdit).length && id) {
      dispatch(actionGetOrder(id));
    }
    

    dispatch(actionGetPractices(0,999));

    if (!Object.keys(kitTypes).length) {
      dispatch(actionGetKitTypes());
    }

    dispatch(actionGetKitsCount());

    if (Object.keys(orderEdit).length && !Object.keys(reservedKits).length) {
      dispatch(actionGetReservedKits(orderEdit._id));
    }

    return () => {
      dispatch(actionSetEditOrder({}));
      dispatch(actionSetReservedKits({}));
    }
  }, []);

  useEffect(() => {
    //Change fields only if there is an ID param present
    if (Object.keys(orderEdit).length && id) {
      if (practices && practices.length) {
        let practiceSelect = document.getElementById("practice");
        practiceSelect.value = orderEdit.ordered_by.practice_id;
        practiceSelect.dispatchEvent(new Event('change'));
      }

      if (kitTypes && Object.keys(kitTypes).length) {
        Object.keys(kitTypes).map((k,i) => {
          const requested = Object.keys(orderEdit).length ? orderEdit.requested_kits.find(r => r.kit_type_id === kitTypes[k]).requested_quantity : 0;
          let typeNumber = document.getElementById(k);
          typeNumber.value = requested;
          typeNumber.dispatchEvent(new Event('change'));
        });
      }
    }
  }, [orderEdit, kitTypes, kitsCount, practices]);

  const autoAssignKits = () => {
    dispatch(actionAutoAssignKits(orderEdit._id));
  }

  return (
    <div className="content user-manual-edit mt-3">

      <Card>
        <CardHeader><h6>{"New order"}</h6></CardHeader>
        <CardBody className="big-form">

          <Form id="order-form" onSubmit={handleSubmit(onSubmit)}>
            <FormGroup>

              <Row>
                <Col>
                  <Label for="practice">{t("practice")}</Label>
                  <Input 
                    className={""}
                    type="select" 
                    name="practice" 
                    id="practice"
                    innerRef={register}
                    disabled={Object.keys(orderEdit).length}
                    onChange={e => {
                      setEdited(true);
                      setPracticePick(e.target.value);
                    }}
                  >
                    <option value="">-</option>
                    {practices && practices.length ? practices.map((p,i) => {
                      return <option key={`p-option-${i}`} value={p._id}>{p.name}</option>
                    }) : (<></>)}
                  </Input>
                </Col>

                <Col>
                  <Label for="status">{t("status")}</Label>
                  <Input 
                    className={""}
                    type="select" 
                    name="status" 
                    id="status"
                    innerRef={register}
                    onChange={e => {
                      setEdited(true);
                    }}
                    disabled={Object.keys(orderEdit).length && orderEdit.status.status_id === "o_st_cancel"}
                  >
                    <option value="o_st_in_preparation">{t("o_st_in_preparation")}</option>
                    <option value="o_st_pending">{t("o_st_pending")}</option>
                    <option value="o_st_cancel">{t("o_st_cancel")}</option>
                    <option value="o_st_readytodeliver">{t("o_st_readytodeliver")}</option>
                    <option value="o_st_receivedbypractice">{t("o_st_receivedbypractice")}</option>
                  </Input>
                </Col>
              </Row>

              <hr2/>
              <h6>{t("available-kits")}:</h6>

              {kitTypes && Object.keys(kitTypes).length ? Object.keys(kitTypes).map((k,i) => {

                const requested = Object.keys(orderEdit).length ? orderEdit.requested_kits.find(r => r.kit_type_id === kitTypes[k]).requested_quantity : 0;
                
                return (
                  <>
                    <br key={`br-${k}`}/>
                    <div className="reserved-kits-container">
                        <div key={`col-1-${k}`} style={{width:"120px"}}>
                          <p key={`label-${k}`} className={kitsCount[kitTypes[k]] < 1 ? "not-available" : ""}>{kitTypes[k]}</p>
                        </div>

                        <div className="d-flex" style={{gap: "10px", alignItems: "baseline"}} key={`col-2-${k}`} sm={5} lg={2}>
                          <Input 
                            key={`input-${k}`}
                            className={""}
                            type="number" 
                            name={k} 
                            id={k}
                            innerRef={register}
                            defaultValue={requested}
                            style={{maxWidth: "50%"}}
                            min={0}
                            onChange={e => {setEdited(true)}}
                            disabled={Object.keys(orderEdit).length && orderEdit.status.status_id === "o_st_cancel"}
                          >
                          </Input>

                          <p className={kitsCount[kitTypes[k]] < 1 ? "not-available" : ""}>{t("available")}: <span className={`${kitsCount[kitTypes[k]] < 1 ? "not-" : ""}available-number`}>{kitsCount[kitTypes[k]]}</span></p>
                        </div>
                    </div>
                    {i < Object.keys(kitTypes).length-1 ? <hr1 /> : <></>}
                  </>
                )
              }) : <></>}
            </FormGroup>

          </Form>

          {reservedKits && Object.keys(reservedKits).length ? (
            <>
              <br/>
              <hr2/>
              <h6>{t("reserved-kits")}:</h6>
            </>
          ): <></>}
          
          {kitTypes && Object.keys(kitTypes).length && Object.keys(reservedKits).length ? Object.keys(kitTypes).map((k,i) => {

            /* FOR PAGINATION LATER
            <>
              <ReservedKitList 
                kitType={k}
                kits={reservedKits[k]}
                kitTypeName={kitTypes[k]}
              />
            </>
          */
            const categoryHasLength = reservedKits && Object.keys(reservedKits).length && reservedKits[kitTypes[k]] && reservedKits[kitTypes[k]].length;

            if (!categoryHasLength) {
              return (<></>)
            }
            return (
              <>
                <div className="reserved-kits-container">
                  <div style={{width:"120px"}}>
                    <p className="type-label" key={`label-${k}`}>{kitTypes[k]}</p>
                  </div>

                  <div>
                    {categoryHasLength ? reservedKits[kitTypes[k]].map((rk,j) => {

                      if (j === 5) {
                        return (<div>{t("nth-remaining").replace("###", reservedKits[kitTypes[k]].length - (j))}</div>);
                      }

                      if (j > 5) {
                        return (<></>);
                      }
                      return (
                        <>
                          <KitOverview reservedKit={rk}/>
                        </>
                      )
                    }) : <></>}
                  </div>
                </div>
                <hr1/>
              </>
            )
          }) : <></>}

          <br/>

          {!Object.keys(orderEdit).length ? (
            <div className="d-flex">
              <Button
                form="order-form"
                size="md"
                color="primary"
                type="reset"
                onClick={(e) => {
                  e.preventDefault();
                  history.goBack();
                }}
              >
                {t("cancel-btn")}
              </Button>

              <Button className="ml-3" disabled={!practicePick.length} form="order-form" size="md" color="info" type="submit">
                {t("save-btn")}
              </Button>
            </div>
            
          ) : (
            <div className="d-flex">
              <Button size="sm" color="primary" onClick={e=> { e.preventDefault(); history.goBack();}}>
                {t("return-btn")}
              </Button>

              {orderEdit.status.status_id !== "o_st_cancel" ? (
                <>
                  <Button className="ml-3" disabled={kitDeleteLoading || edited} size="md" color="info" onClick={e=> { e.preventDefault(); autoAssignKits();}}>
                    {t("assign-btn")}
                  </Button>

                  <Button className="ml-3" disabled={kitDeleteLoading || !edited} size="md" color="info" form="order-form" type="submit">
                    {t("update-btn")}
                  </Button>
                </>
              ) : (<></>)}
            </div>
          )}

          
        </CardBody>
      </Card>
    </div>
  );
};

export default translate("practice-orders")(PracticeOrdersForm);
